import UploadMedia from './UploadMedia';

export default { UploadMedia };
